import { combineReducers } from 'redux';
// @ts-expect-error untyped dep
import notifications from 'ReduxMessenger/reducers/Notifications';
import auth from './auth';
import entities from './entities';
import errors from './errors';
import alerts from './alerts';
import interactions from './interactions';
import requestStatuses from './requestStatuses';
import securityPhoneNumber from './security/securityPhoneNumber';
import securityPhoneNumberSetup from './security/securityPhoneNumberSetup';
import twoFactorAuth from './twoFactorAuth';
import requestStatusesOverride from './requestStatusesOverride';
import { loginEmails } from '../login-emails/reducers';
import { sendAsEmails } from '../send-as-emails/reducers';
import { password } from '../password/reducers';
import navConfig from './navConfig';
import userCanGdprDeleteSelf from './userCanGdprDeleteSelf';
import hubContact from './hubContact';
import messageSettings from './messageSettings';
import passkeys from './passkeys';
import sso from './sso';
export default combineReducers({
  auth,
  interactions,
  entities,
  errors,
  alerts,
  requests: requestStatusesOverride(requestStatuses),
  twoFactorAuth,
  securityPhoneNumber,
  securityPhoneNumberSetup,
  notifications,
  loginEmails,
  sendAsEmails,
  password,
  navConfig,
  userCanGdprDeleteSelf,
  hubContact,
  messageSettings,
  passkeys,
  sso
});